module.exports = __webpack_public_path__ + "static/img/nineab.e9728ce9.png";